import React from 'react'
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom'
import green_switch_cma from '../assets/images/green_switch_cma.png'
import surgent from '../assets/images/2nd.png';
import purpledot from '../assets/images/purple_squre_dots.b6e7dbcc.svg';
import yellowdot from '../assets/images/yellow_squre_dots.a8deef14.svg';
import greenTickFill from '../assets/images/greenTickFill.svg'

function CmaReview() {

    return (
        <>
            <Helmet>
                <title>US CMA Review in India by KC Globed: Affordable CMA Certification</title>

                <meta name="description" content="Discover the US CMA Review in India with KC Globed. Get detailed information on costs, affordable pricing and expert training to achieve CMA certification." />

                <link rel="canonical" href="" />

                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className="overflow-hidden bg-placement-hero bg-cover w-full">
                <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
                    <img src={green_switch_cma} alt="CMA Fees" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[0] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
                    <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
                        <div className="mx-auto lg:max-w-5xl">
                            <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[90%] mb-2 lg:leading-[56px]"><span className="block">KC GlobEd CMA Review Course</span></h1>

                            <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                                <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                                    <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                                        className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                                    >
                                        Enquiry Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative p-4 md:p-8 lg:p-0 py-[91px]">
                <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
                <div className="flex flex-col items-center">
                    <div tabindex="0" style={{ transform: 'none' }}>
                        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-4 items-center xs:max-w-xl lg:max-w-6xl group h-full bg-white">
                            <div className="flex flex-col ml-0 lg:ml-6">
                                <h2 className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl"><span className='uppercase text-xl'>Top CMA</span> <span className="text-primary_text mt-3 lg:pb-4">Review Course in India</span></h2>
                                <p className='text-[15px] text-base md:text-medium text-left text-dark_text mb-3'>Looking for the <strong>best CMA review course</strong> to prepare for the global Certified Management Accountant (CMA) exam? While our reputation as the Best CMA Review Course in India stands strong, KC Globed brings the same excellence, innovation, and support to our CMA review courses as well. Prepare to succeed with globally trusted materials and expert guidance.</p>
                            </div>
                            <img src={surgent} alt="Best CMA Review Course In India" className="mt-6 lg:pl-10" />
                        </div>
                    </div>
                </div>
                <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
            </div>

            <div class="bg-[#f2f2f2] relative lg:py-2 lg:px-10 py-0 py-[71px] pb-36">
                <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
                <div class="flex flex-col items-center">
                    <div class="relative overflow-hidden">
                        <div class="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
                            <div class="max-w-3xl text-center mx-auto">
                                <h2 style={{ lineHeight: '50px' }} className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl"><span className='uppercase text-xl'>Incredible Reasons to Choose </span> <span className="text-primary_text mt-3 lg:pb-4"> KC Globed's CMA Review Course </span></h2>
                                <p>KC Globed’s CMA exam review courses are designed with the modern learner in mind. Here’s why our program stands out:</p>
                            </div>
                        </div>
                    </div>
                    <div class="lg:max-w-5xl px-4 mb-10">
                        <div class="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1">
                            <div tabindex="0" style={{ transform: "none" }}>
                                <div
                                    class="group flex flex-col lg:h-[14rem] border-2 border-[#E6D9FF] rounded-xl transition bg-white transform transition-transform duration-300 hover:scale-110"
                                >
                                    <div
                                        class="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div class="p-6 flex-grow">
                                                <p class="flex font-sans text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[4%] h-[20px] inline-block float-left mr-2'><img src={greenTickFill} className='w-[17px] inline-block' alt="Customized Adaptive" /></span>
                                                   <span className='w-[96%]'> Comprehensive <strong>CMA review materials</strong> aligned with IMA’s latest syllabus</span>
                                                </p>
                                                <p class="flex font-sans text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[4%] h-[20px] mr-2'><img src={greenTickFill} className='w-[17px] inline-block' alt="Real-Time" /></span>
                                                    <span className='w-[96%]'>Real-time doubt clearing and expert mentoring</span>
                                                </p>
                                                <p class="flex font-sans text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[4%] h-[20px] mr-2'><img src={greenTickFill} className='w-[17px] inline-block' alt="Optimized" /></span>
                                                    <span className='w-[96%]'>Mobile-friendly access for studying anytime, anywhere</span>
                                                </p>
                                                <p class="flex font-sans text-gray-700  text-[16px] mb-2">
                                                    <span className='w-[4%] h-[20px] mr-2'><img src={greenTickFill} className='w-[17px] inline-block' alt="Unlimited" /></span>
                                                    <span className='w-[96%]'>Progress tracking and performance analytics</span>
                                                </p>
                                                <p class="flex font-sans text-gray-700  text-[16px]">
                                                    <span className='w-[4%] h-[20px] mr-2'><img src={greenTickFill} className='w-[17px] inline-block' alt="Unlimited" /></span>
                                                    <span className='w-[96%]'>Adaptive learning pathways to suit different student needs</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
            </div>

            <div className="bg-first-step py-5 bg-center bg-no-repeat bg-cover">
                <div className="flex flex-col items-center">
                    <div className="relative overflow-hidden">
                        <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
                            <div className="max-w-3xl text-center mx-auto">
                                <h2 className='font-bold text-white text-3xl'>Enroll Today for Success.</h2>
                                <p className='text-[#fff] font-semibold'>Start your CMA journey today with the best resources in the industry!</p>
                                <div className='text-center mt-3'>
                                <Link to="" class="bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-2 text-[16px] font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary cursor-pointer inline-block ml-3">Enquire Now</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </>
    )
}
export default CmaReview;
